<template>
  <div class="about">
    <h1>A site that lists events to better the world</h1>
  </div>
</template>
